import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import Header from '../components/HeaderComponent';
import { connect } from 'react-redux';
import "../styles/ProcurementPortalStyles.css";
import { Redirect } from 'react-router-dom';
import { fetchLeadDetailFollowup, updateLeadData } from '../actions/followupActions';
import { followupTaskColumns } from "../config/column_fields";
import Select from 'react-select';
import axios from 'axios';
import ReactTable from "react-table";
import url from '../config';
import moment from 'moment'


class FollowupDesktop extends Component {

    constructor() {
        super();
        this.state = {
            userObj: {},
            received: false,
            leadData: {},
            editedData: {},
            edit: false,
            leadComments: [],
            newComment: ''
        };

        this.historyColumns = [
            {
                Header: 'Time',
                accessor: 'timestamp',
                Cell: row => {

                    return moment(+row.original.timestamp).format('DD/MM/YYYY hh:mm a');
                }
            },
            {
                Header: 'Updated By',
                accessor: 'updatedBy',
                Cell: row => {
                    return (row.original.updatedBy.split('@')[0].split('.')[0]) + ' ' + row.original.updatedBy.split('@')[0].split('.')[1]
                }
            },
            {
                Header: 'Field Name',
                accessor: 'updatedField'
            },
            {
                Header: 'Old Value',
                accessor: 'updatedFrom'
            },
            {
                Header: 'New Value',
                accessor: 'updatedTo'
            }
        ];
    }

    componentWillMount() {
        this.props.fetchLeadDetailFollowup(this.props.match.params.id);
        if (localStorage.getItem("userObj")) {
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            this.setState({
                userObj
            })
        }
    }

    handleNewCommentChange = (e) => {
        this.setState({
            newComment: e.target.value
        })
    }

    handleSubmitCommentClick = () => {
        if (!this.state.newComment) {
            alert('Please enter commemt');
            return;
        }
        let { BITRIX_ID, QUOTE_ID } = this.state.leadData;
        this.props.updateLeadData({ BITRIX_ID: BITRIX_ID, QUOTE_ID: QUOTE_ID }, { nextActionComment: this.state.newComment, QUOTE_ID: QUOTE_ID }, true);
        let updatedComments = [...this.state.leadComments, {
            timestamp: Date.now(),
            commentBody: this.state.newComment,
            commentedBy: this.state.userObj.email
        }]
        this.setState({
            newComment: '',
            leadComments: updatedComments
        })
    }

    componentWillReceiveProps({ leadDetailReceived, leadData, leadComments }) {
        this.setState({ received: leadDetailReceived, leadData: leadData, leadComments })
    }

    handleEditClick = () => {
        this.setState({
            edit: true,
            editedData: this.props.leadData
        })
    }

    handleCancelClick = () => {
        this.setState({
            edit: false
        })
    }

    handleSaveClick = () => {
        let { leadData, editedData } = this.state;
        if ((leadData.ACTIVE == 1 && editedData.ACTIVE == 0) && !editedData.dropOffReason) {
            alert("Please select drop off resaon");
            return;
        }
        if (leadData.NEXT_ACTION_DATE != editedData.NEXT_ACTION_DATE && !editedData.nextActionComment) {
            alert("Please enter comment");
            return;
        }
        if (leadData.PROSPECT != editedData.PROSPECT && editedData.PROSPECT != "Sold" && !editedData.nextActionComment) {
            alert("Please enter comment");
            return;
        }
        this.props.updateLeadData(leadData, editedData);
        let updatedLeadData = {};
        Object.keys(leadData).forEach(key => {
            updatedLeadData[key] = editedData[key];
        })
        this.setState({
            leadData: JSON.parse(JSON.stringify(updatedLeadData)),
            editedData: {
                ...(JSON.parse(JSON.stringify(updatedLeadData))),
                nextActionComment: '',
                commentSelect: ''
            },
            edit: false
        }, () => {
            console.log(this.state.editedData);
        })
    }

    handleFieldChange = (e) => {
        let { name, value } = e.target;
        console.log(name, value);
        if (name == "NEXT_ACTION_DATE") {
            if (!value) return;
            value = moment(value).format("YYYYMMDD");
        }
        if (name == "commentSelect" && value) {
            this.setState({
                editedData: {
                    ...this.state.editedData,
                    [name]: value,
                    nextActionComment: value
                }
            })
            return;
        }
        if (name == "dropReasonSelect" && value) {
            this.setState({
                editedData: {
                    ...this.state.editedData,
                    [name]: value,
                    dropOffReason: value
                }
            })
            return;
        }
        this.setState({
            editedData: {
                ...this.state.editedData,
                [name]: value
            }
        })
    }

    render() {

        const { leadData = {}, editedData = {}, edit = false, leadComments = [] } = this.state;
        const { mapping = {} } = this.props;
        const stateOptions = mapping.states || []
        const prospectOptions = mapping.prospect || []
        const responsibleOptions = (mapping.employeeData || []).map(emp => emp.e_name);
        const commentsSorted = (leadComments || []).sort((a, b) => +b.timestamp - +a.timestamp)
        return (
            <div>
                <Header />
                <div className={`container-fluid procurementMainDiv`}>

                    <div className="d-flex justify-content-between align-items-center mb-4">
                        {/* Heading */}
                        <h4
                            style={{
                                borderBottom: '2px solid #007bff',
                                paddingBottom: '4px',
                                color: '#007bff',
                                margin: 0,
                            }}
                        >
                            Lead #{leadData.BITRIX_ID} &nbsp;&nbsp;&nbsp;&nbsp;   Quote Id - {leadData.QUOTE_ID}
                        </h4>

                        {/* Buttons */}
                        <div>

                            {edit ? <button
                                className="btn btn-secondary"
                                style={{ fontSize: '0.9rem', padding: '6px 16px' }}
                                onClick={this.handleCancelClick}
                            >
                                Cancel
                            </button> : ""}
                            {edit ? <button
                                className="btn btn-success me-2"
                                style={{ fontSize: '0.9rem', padding: '6px 16px' }}
                                onClick={this.handleSaveClick}
                            >
                                Save
                            </button> : ""}
                            {!edit ? <button
                                className="btn btn-success me-2"
                                style={{ fontSize: '0.9rem', padding: '6px 16px' }}
                                onClick={this.handleEditClick}
                            >
                                Edit
                            </button> : ""}
                        </div>
                    </div>




                    <div className="row g-5">

                        {/* Column 1 */}
                        <div className="col-md-4">
                            <div
                                className="card shadow-lg rounded-4 border-0 hover-shadow"
                                style={{ backgroundColor: '#f9f9f9', borderRadius: '1rem' }}
                            >
                                <div className="card-body p-4">
                                    <h6 className="fw-semibold mb-3" style={{ color: '#6c757d', letterSpacing: '0.5px' }}>
                                        Contact Info
                                    </h6>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Name
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="TITLE" defaultValue={leadData.TITLE} className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} /> : leadData.TITLE}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Phone
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="PHONE_VALUE" defaultValue={leadData.PHONE_VALUE} className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} /> : leadData.PHONE_VALUE}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Email
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="EMAIL_VALUE" defaultValue={leadData.EMAIL_VALUE} className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} /> : leadData.EMAIL_VALUE}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            State
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? (
                                                <select className="form-select form-control" defaultValue={leadData.STATE} style={{ fontSize: '1.1rem' }} name="STATE" onChange={this.handleFieldChange} >
                                                    {stateOptions.map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                leadData.STATE
                                            )}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            City
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? (
                                                <select className="form-select form-control" defaultValue={leadData.ADDRESS_CITY} style={{ fontSize: '1.1rem' }} name="ADDRESS_CITY" onChange={this.handleFieldChange} >
                                                    {(mapping.stateRegionMap && mapping.stateRegionMap[editedData.STATE] ? mapping.stateRegionMap[editedData.STATE] : []).map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                leadData.ADDRESS_CITY
                                            )}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center">
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Address
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="ADDRESS" defaultValue={leadData.ADDRESS} className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} /> : leadData.ADDRESS}
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        {/* Column 2 */}
                        <div className="col-md-4">
                            <div
                                className="card shadow-lg rounded-4 border-0 hover-shadow"
                                style={{ backgroundColor: '#f9f9f9', borderRadius: '1rem' }}
                            >
                                <div className="card-body p-4">
                                    <h6 className="fw-semibold mb-3" style={{ color: '#6c757d', letterSpacing: '0.5px' }}>
                                        Stage Info
                                    </h6>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Prospect
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? (
                                                <select className="form-select form-control" defaultValue={leadData.PROSPECT} style={{ fontSize: '1.1rem' }} name="PROSPECT" onChange={this.handleFieldChange} >
                                                    {prospectOptions.map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                leadData.PROSPECT
                                            )}
                                        </div>
                                    </div>


                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Next action date
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="date" name="NEXT_ACTION_DATE" defaultValue={leadData.NEXT_ACTION_DATE && moment(leadData.NEXT_ACTION_DATE, "YYYYMMDD").isValid() ? moment(leadData.NEXT_ACTION_DATE, "YYYYMMDD").format("YYYY-MM-DD") : ""} className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} /> : (leadData.NEXT_ACTION_DATE && moment(leadData.NEXT_ACTION_DATE, "YYYYMMDD").isValid() ? moment(leadData.NEXT_ACTION_DATE, "YYYYMMDD").format("DD MMM YYYY") : "")}
                                        </div>
                                    </div>


                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Responsible
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit && mapping.fromCentralTeam ? (
                                                <select className="form-select form-control" defaultValue={leadData.N_RESPONSIBLE} style={{ fontSize: '1.1rem' }} name="N_RESPONSIBLE" onChange={this.handleFieldChange} >
                                                    {responsibleOptions.map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                leadData.N_RESPONSIBLE
                                            )}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Active
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit && mapping.fromCentralTeam && (editedData.PROSPECT == "Cold") ? (
                                                <select className="form-select form-control" defaultValue={leadData.ACTIVE} style={{ fontSize: '1.1rem' }} name="ACTIVE" onChange={this.handleFieldChange} >
                                                    <option value={1}>Yes</option>
                                                    <option value={0}>No</option>
                                                </select>
                                            ) : (
                                                leadData.ACTIVE
                                            )}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Recycle Count
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {leadData.recycleCount}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center">
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Last recycle date
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {leadData.lastRecycleDate && moment(leadData.lastRecycleDate, "YYYYMMDD").isValid() ? moment(leadData.lastRecycleDate, "YYYYMMDD").format("DD MMM YYYY") : ""}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div
                                className="card shadow-lg rounded-4 border-0 hover-shadow"
                                style={{ backgroundColor: '#f9f9f9', borderRadius: '1rem' }}
                            >
                                <div className="card-body p-4">
                                    <h6 className="fw-semibold mb-3" style={{ color: '#6c757d', letterSpacing: '0.5px' }}>
                                        Others
                                    </h6>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Sales Opinion
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {leadData.salesOpinion}
                                        </div>
                                    </div>


                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Select comment
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? (
                                                <select className="form-select form-control" style={{ fontSize: '1.1rem' }} name="commentSelect" onChange={this.handleFieldChange} >
                                                    <option value="">Select</option>
                                                    {(mapping.comment || []).map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>


                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Comment
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="nextActionComment" className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} value={editedData.nextActionComment} /> : ""}
                                        </div>
                                    </div>

                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Select drop off reason
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? (
                                                <select className="form-select form-control" style={{ fontSize: '1.1rem' }} name="dropReasonSelect" onChange={this.handleFieldChange} >
                                                    <option value="">Select</option>
                                                    {(mapping.dropOffReason || []).map(val => <option value={val}>{val}</option>)}
                                                </select>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>


                                    <div className="row py-3 align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                        <div className="col-5 text-end text-secondary fw-semibold px-3" style={{ fontSize: '0.9rem' }}>
                                            Drop off reason
                                        </div>
                                        <div className="col-7 px-3" style={{ fontSize: '1.1rem', color: '#212529' }}>
                                            {edit ? <input type="text" name="dropOffReason" className="form-control" style={{ fontSize: '1.1rem' }} onChange={this.handleFieldChange} value={editedData.dropOffReason} /> : ""}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="card shadow-lg rounded-4 border-0 mt-5">
                        <div className="card-body p-4">
                            <h6 className="text-muted fw-semibold mb-4">Comments</h6>

                            <div className="mb-4" style={{ maxHeight: '200px', overflowY: 'auto' }}>

                                {
                                    commentsSorted.map(comment => <div className="mb-3 p-3 bg-light rounded-3">
                                        <div className="d-flex justify-content-between mb-1">
                                            <span className="fw-bold">{comment.commentedBy}</span>
                                            <span className="text-muted fs-7">{moment(+comment.timestamp).format("YYYY-MM-DD HH:mm:ss")}</span>
                                        </div>
                                        <div className="fs-6">
                                            {comment.commentBody}
                                        </div>
                                    </div>)
                                }
                            </div>

                            <div className="mt-3">
                                <textarea
                                    className="form-control mb-2"
                                    rows="3"
                                    placeholder="Add a new comment..."
                                    onChange={this.handleNewCommentChange}
                                ></textarea>
                                <div className="text-end">
                                    <button className="btn btn-primary px-4" onClick={this.handleSubmitCommentClick}>Add Comment</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card shadow-lg rounded-4 border-0 mt-5">
                        <div className="card-body p-4">
                            <h6 className="text-muted fw-semibold mb-4">Tasks</h6>
                            <ReactTable
                                data={this.props.leadTasks}
                                columns={followupTaskColumns}
                                defaultPageSize={5}
                                className="-striped -highlight"
                                showPaginationTop={false}
                                showPaginationBottom={true}
                            />
                        </div>
                    </div>

                    <div className="card shadow-lg rounded-4 border-0 mt-5">
                        <div className="card-body p-4">
                            <h6 className="text-muted fw-semibold mb-4">History</h6>
                            <ReactTable
                                data={this.props.leadHistory}
                                columns={this.historyColumns}
                                defaultPageSize={5}
                                className="-striped -highlight"
                                showPaginationTop={false}
                                showPaginationBottom={true}
                            />
                        </div>
                    </div>


                </div>
            </div>
        )
    }

}

function mapStateToProps({ followup }) {
    let { leadData = {}, leadDetailReceived = false, mapping = {}, leadComments = [], leadTasks = [], leadHistory = [] } = followup;
    return {
        leadData,
        leadDetailReceived,
        mapping,
        leadComments,
        leadTasks,
        leadHistory
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult, fetchLeadDetailFollowup, updateLeadData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowupDesktop);